import React from 'react';
import Helmet from 'react-helmet';
import PageLayout from '../components/PageLayout';
import styles from './info.module.scss';

const InfoTemplate = (props) => {
  const { frontmatter: { title, image }, html } = props.data.markdownRemark;
  return (
    <PageLayout location={props.location}>
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        {html ? <meta property="og:description" content={html.replace(/<\/?[^>]+(>|$)/g, "")} /> : '' }
        {image ? <meta property="og:image" content={image} /> : ''}
        {image ? <meta property='twitter:image:src' content={image} /> : ''}
      </Helmet>
      <div className={styles.content}>
        {/* <h1 className={styles.title}>{title}</h1> */}
        <div className='markdown' dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </PageLayout>
  );
}

export default InfoTemplate;

export const pageQuery = graphql`
query GetInfo($path: String!) {
  markdownRemark(fields: { path: { eq: $path } }) {
   html
   frontmatter {
      title,
      image
    }
  }
}
`;
